import { __assign } from "tslib";
import React from 'react';
var LeftArrow = (React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" }),
    React.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })));
var RightArrow = (React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" }),
    React.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })));
var icons = {
    left: LeftArrow,
    right: RightArrow,
};
var Icons;
(function (Icons) {
    Icons["LeftArrow"] = "left";
    Icons["RightArrow"] = "right";
})(Icons || (Icons = {}));
export var Dots = function (props) {
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", width: props.width || 24, height: props.height || 24, fill: props.fill || '#000' }, props), icons[props.icon]));
};
Dots.icons = Icons;
//# sourceMappingURL=Dots.js.map